


<template>
<div class="pre-customer-profile">
  <div class="mb-8">
    <p class="py-4 px-6 bg-gray-100 border rounded font-bold">{{ options.instructions }}</p>
  </div>
  <div>
    <h2 class="font-bold text-xl pb-2 border-b-2 pl-4">{{ options.label }}</h2>
  </div>
  <div class="" v-if="costs">

    <table class="w-full bg-white border-r border-l text-sm">
      <thead>
        <tr class="">
          <th class="text-left px-4 align-bottom border-r bg-gray-100">Returned Mail - Cost Savings Opportunity</th>
          <th class="align-bottom border-r bg-gray-100"></th>
          <th class="align-bottom border-r bg-gray-100 w-96 text-right">Returned Mail Cost</th>
        </tr>
      </thead>
      <tbody>

      <tr>
        <td>Monthly Return Mail Volume</td>
        <td>{{ costs.monthlyVolume | decimal(0) }}</td>
        <td>${{ costs.monthlyCostBase | decimal(0) }}</td>
      </tr>
      <tr>
        <td>Average Postage Cost per Piece for Returned Mail</td>
        <td>${{ costs.averagePostageCost | decimal(2) }}</td>
        <td></td>
      </tr>
      <tr>
        <td>Average Print Cost per Piece for Envelope and Contents of Returned Mail</td>
        <td>${{ costs.averagePrintCost | decimal(2) }}</td>
        <td></td>
      </tr>
      <tr>
        <td>Average Number of Times a Piece of Returned Mail is Resent to Recipients</td>
        <td>{{ costs.averageResentBack | decimal(0) }}</td>
        <td></td>
      </tr>
      <tr>
        <td>Monthly Processing Cost of Returned Mail</td>
        <td>${{ costs.monthlyProcessingCost | decimal(0) }}</td>
        <td>${{ costs.monthlyProcessingCost | decimal(0) }}</td>
      </tr>
      <tr class="font-bold">
        <td>Current Monthly Cost of Returned Mail</td>
        <td></td>
        <td>${{ costs.monthlyCostReturned | decimal(0) }}</td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>Cost to Update Data in CRM to Fix Addresses</td>
        <td>${{ costs.costToUpdateCRM | decimal(0) }}</td>
        <td>${{ costs.costToUpdateCRM | decimal(0) }}</td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>% of Returned Mail that is Reprinted</td>
        <td>{{ costs.percentReprinted | decimal(0) }}%</td>
        <td>${{ costs.percentReprintedCost | decimal(0) }}</td>
      </tr>
      <tr>
        <td>% of Returned Mail that is Resent to Recipients</td>
        <td>{{ costs.percentResent | decimal(0) }}%</td>
        <td>${{ costs.percentResentCost | decimal(0) }}</td>
      </tr>
      <tr>
        <td>Cost of Resent Mail</td>
        <td></td>
        <td>${{ costs.monthlyCostResent | decimal(0) }}</td>
      </tr>
      <tr class="font-bold">
        <td>TOTAL COST OF RETURNED MAIL</td>
        <td></td>
        <td>${{ costs.monthlyCostTotal | decimal(0) }}</td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>% of Returned Mail that could be reduced by cleansing the mail list</td>
        <td>{{ costs.percentCleanseReduction | decimal(0) }}%</td>
        <td>${{ costs.monthlyCostSavings | decimal(0) }}</td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr class="font-bold">
        <td>YEARLY COST OF RETURNED MAIL</td>
        <td></td>
        <td>${{ costs.yearlyCostTotal | decimal(0) }}</td>
      </tr>
      <tr class="font-bold">
        <td>YEARLY COST SAVINGS BY CLEANSING LISTS <small>(Reducing Returns and Eliminating the Cost to Resend Mail)</small></td>
        <td></td>
        <td>${{ costs.yearlyCostSavings | decimal(0) }}</td>
      </tr>


      </tbody>

    </table>






    <div class="pt-4 border-t">
      <div class="pb-4 flex justify-between">
        <div class="pr-4">
          <button class="button button-green" @click="$emit('summary')">Save & Go to Summary</button>
        </div>
        <div class="pl-4">
          <button class="button button-blue button-next" @click="$emit('next')">Save & Next ROI <img class="inline-block ml-2 h-3" src="../assets/icons/next-arrow-icon.svg" /></button>
        </div>

      </div>
    </div>

  </div>
</div>
</template>

<script>
//import NumberInput from "@/components/NumberInput";
export default {
    name: "return-mail-roi-table",
  components: {},
  props: {
      options: {
        default: function(){
          return {
            label: "Mail ROI",
            costsKey: "",
            instructions: "ROI instructions"
          }
        }
      }
    },
    data: function(){
        return {
          capitalRows: [
            { label: "Software", key:"software" },
            { label: "Hardware", key:"hardware" },
            { label: "Installation", key:"installation" },
          ],
          expensesRows: [
            { label: "Annual Lease Expense", key:"lease" },
            { label: "Maintenance", key:"maintenance" },
            { label: "Training", key:"training" },
          ],
          cols: [
              { label: "Initial Investment", key: "initial"},
            { label: "Year 1", key: "year1"},
            { label: "Year 2", key: "year2"},
            { label: "Year 3", key: "year3"},
            { label: "Year 4", key: "year4"},
            { label: "Year 5", key: "year5"},

          ]
        }
        },
    methods: {
      onChange: function(){
        this.$emit("change");
      }
    },
    computed: {
      costs: function(){
        if(this.$store.state.workflowAssessment && this.$store.state.workflowAssessment.costs){
            return this.$store.state.workflowAssessment.costs.returnMail;
        }

        return null;
      }
    }
}
</script>

<style scoped>


.pre-customer-profile {

}

td {
  @apply text-right py-2 px-4 border bg-white w-16;

}

td:nth-child(1) {
  @apply pl-4 text-left w-96;
}

</style>